import {Operation} from "./Operation.js";
import jStat from "jstat";
import {isEmpty} from "weed-js";


export class Variance extends Operation {

    static displayName() {
        return "Variance";
    }

    static isNumeric() {
        return true;
    }

    static isCategorical() {
        return false;
    }

    static handlesDate() {
        return false; // Variance is not typically applicable to date types
    }

    incrementAggregation(newValue) {
        if (this.currValue === null) {
            this.currValue = [newValue || 0];
        }
        this.currValue.push(newValue);
    }

    finish(globalAggregation) {
        if (isEmpty(this.currValue)) {
            return 0; // If no values were aggregated, return 0
        }
        if (this.currValue.length < 2) {
            return 0; // Variance is undefined for less than two values
        }
        return jStat.variance(this.currValue, true); // Use population variance
    }
}

export default Variance;
